
import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-survey-single-choice',
  templateUrl: './preview-survey-single-choice.component.html',
  styleUrls: ['./preview-survey-single-choice.component.scss']
})
export class PreviewSurveySingleChoiceComponent {
  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  constructor(public sanitizer: DomSanitizer) { }
}
